import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { fontWeight } from 'src/assets/fonts-config';
import { MainTableBodyCell, MainTableBodyRow, MainTableFakeLink, MainTableHeaderCell, MainTableHeaderRow, MainTableLink, MainTableWrapper } from 'src/components/Table/Table.style';

export const ActionButton = styled(MainTableFakeLink, { label: 'ActionButton' })`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
`;

export const Hr = styled('hr', { label: 'Hr' })`
    background: #d8dce4;
    border: 0;
    display: block;
    height: 1px;
    margin: 4px 0 0;
`;

export const BackButton = styled('button', { label: 'BackButton' })`
    background: transparent;
    border: none;
    color: #888;
    cursor: pointer;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    line-height: 2;
`;

export const TableWrapper = styled(MainTableWrapper, { label: 'TableWrapper' })`
    empty-cells: show;
`;

export const TableHeaderRow = styled(MainTableHeaderRow, { label: 'TableHeaderRow' })``;
export const TableHeaderCell = styled(MainTableHeaderCell, { label: 'TableHeaderCell' })`
    /* width: calc((100% - 80px) / 2);
    &:nth-of-type(3) {
        width: 80px;
    } */
`;

export const TableBodyRow = styled(MainTableBodyRow, { label: 'TableBodyRow' })``;
export const TableBodyCell = styled(MainTableBodyCell, { label: 'TableBodyCell' })`
    /* width: calc((100% - 80px) / 2);
    &:nth-of-type(3) {
        padding: 0 !important;
        text-align: center;
        width: 80px;
    } */
`;


export const TableLink = styled(MainTableLink, { label: 'TableLink' })``;


export const HeaderNav = styled('nav', { label: 'HeaderNav' })`
    align-items: center;
    display: flex;
    justify-content: space-between;
`;

export const ButtonsWrapper = styled('div', { label: 'ButtonsWrapper' })`
    display: flex;
`;

const styledButton = css`
    background: #3d76ca;
    border-radius: 4px;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    font-weight: ${fontWeight.bold};
    height: 32px;
    line-height: 1.2143;
    padding: 8px 16px;
    text-decoration: none;
`;

export const HeaderLinkButton = styled('a', { label: 'HeaderLinkButton' })`
    ${styledButton};
    margin-right: 8px;
`;

export const HeaderButton = styled('button', { label: 'HeaderButton' })`
    ${styledButton};
`;
